export default {
  root: {
    class: [
      // Sizing and Shape
      'min-w-[12rem]',

      // Colors
      'bg-gray-800',
      'text-white/80',
      'border border-white/5'
    ]
  },
  wrapper: {
    class: [
      // Overflow
      'overflow-auto'
    ]
  },
  list: {
    class: 'list-none m-0'
  },
  item: ({ context }) => ({
    class: [
      // Font
      'font-sans',
      'leading-none',

      // Position
      'relative',

      // Shape
      'border-0',

      // Spacing
      'm-0',
      'py-3 px-5',

      // Color
      { 'text-white/80': !context.focused && !context.selected },
      { 'bg-surface-600/60 text-white/80': context.focused && !context.selected },
      { 'bg-primary-400/40 text-white/80': context.focused && context.selected },
      { 'bg-primary-400/40 text-white/80': !context.focused && context.selected },

      //States
      { 'hover:bg-surface-600/80': !context.focused && !context.selected },
      { 'hover:text-white hover:bg-surface-600/80': context.focused && !context.selected },
      'focus-visible:outline-hidden focus-visible:outline-offset-0 focus-visible:ring-3 focus-visible:ring-inset focus-visible:ring-primary-300/50',

      // Transitions
      'transition-shadow',
      'duration-200',

      // Misc
      'cursor-pointer',
      'overflow-hidden',
      'whitespace-nowrap'
    ]
  }),
  itemgroup: {
    class: [
      //Font
      'font-bold',

      // Spacing
      'm-0',
      'py-3 px-5',

      // Color
      'text-white/80',
      'bg-surface-600/80',

      // Misc
      'cursor-auto'
    ]
  },
  header: {
    class: [
      // Spacing
      'py-3 px-5',
      'm-0',

      //Shape
      'border-b',

      // Color
      'text-white/80',
      'bg-surface-800',
      'border-surface-600'
    ]
  },
  filtercontainer: {
    class: 'relative'
  },
  filterinput: {
    class: [
      // Font
      'font-sans',
      'leading-none',

      // Sizing
      'pr-7 py-3 px-3',
      '-mr-7',
      'w-full',

      //Color
      'text-white/80',
      'bg-surface-900',
      'border-surface-700',

      // Shape
      'border',
      'appearance-none',

      // Transitions
      'transition',
      'duration-200',

      // States
      'hover:border-primary-300',
      'focus:ring-3 focus:outline-hidden focus:outline-offset-0',
      'focus:ring-primary-300/50',

      // Misc
      'appearance-none'
    ]
  },
  filtericon: {
    class: ['absolute', 'top-1/2 right-3', '-mt-2']
  },
  emptymessage: {
    class: [
      // Font
      'leading-none',

      // Spacing
      'py-3 px-5',

      // Color
      'text-white/80',
      'bg-transparent'
    ]
  }
}
